import firebase from 'firebase'
var config = {
  apiKey: "AIzaSyBgRBUnUl69pnLDtFK77MFVcNHRW955eYk",
  authDomain: "dwell-ist.firebaseapp.com",
  databaseURL: "https://dwell-ist.firebaseio.com",
  projectId: "dwell-ist",
  storageBucket: "dwell-ist.appspot.com",
  messagingSenderId: "711867570937"
};
if (!firebase.apps.length) {
  firebase.initializeApp(config);
}
export const googleProvider = new firebase.auth.GoogleAuthProvider();
export const facebookProvider = new firebase.auth.FacebookAuthProvider();
export const auth = firebase.auth();
export default firebase;



// WEBPACK FOOTER //
// ./src/firebase.js